import Image from "next/image";

export function Logo() {
  return (
    <div className="flex items-center gap-2">
      <Image
        src="/logo.svg"
        alt="MedChartScan Logo"
        width={32}
        height={32}
        className="h-8 w-auto"
      />
      <span className="text-xl font-bold font-headline tracking-tight">
        MedChartScan
      </span>
    </div>
  );
}
